<template>
  <div id="app" :class="{'chrome': checkChrome, 'firefox': checkFirefox, 'safari': checkSafari, 'isMac': checkMac, 'ios': checkIOS }">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      checkSafari: false,
      checkChrome: false,
      checkFirefox: false,
      checkIOS: false,
      checkMac: false
    }
  },
  mounted () {
    var device = navigator.userAgent.toLowerCase()
    var isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

    // add class for chrome in macos
    if (device.indexOf('chrome') > -1) {
      this.checkChrome = true
    }
    // add class for firefox in macos
    if (device.indexOf('firefox') > -1) {
      this.checkFirefox = true
    }
    if (isMac) {
      // add class for safari
      if (device.indexOf('safari') > -1) {
        this.checkSafari = true
      }
    } else {
      this.checkMac = true
    }
    if (isIOS) {
      this.checkIOS = true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue